import { render, staticRenderFns } from "./closeBtn.vue?vue&type=template&id=c5218440&scoped=true&"
import script from "./closeBtn.vue?vue&type=script&lang=js&"
export * from "./closeBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5218440",
  null
  
)

export default component.exports